var _this = this;
import * as tslib_1 from "tslib";
import { ESRI } from '../../../esri-loader-util';
export var CreateBasemapsFromConfig = function (basemapConfig) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var _a, Basemap, PortalItem, WebTileLayer, basemap;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([ESRI.Basemap, ESRI.PortalItem, ESRI.WebTileLayer])];
            case 1:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 3]), Basemap = _a[0], PortalItem = _a[1], WebTileLayer = _a[2];
                basemap = new Basemap({
                    id: basemapConfig.title,
                    thumbnailUrl: basemapConfig.tileUrl + basemapConfig.thumbnailTile,
                    title: basemapConfig.title
                });
                if (basemapConfig.portalItemId === undefined) {
                    basemap.baseLayers.add(new WebTileLayer({
                        urlTemplate: basemapConfig.tileUrl + basemapConfig.tileTemplate,
                        copyright: basemapConfig.copyrightText
                    }));
                }
                else {
                    basemap.portalItem = new PortalItem({
                        id: basemapConfig.portalItemId
                    });
                }
                return [2 /*return*/, basemap];
        }
    });
}); };
export var BasemapConfigurationArrayConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value);
    }
    return value ? value : [];
};
